import React, { Dispatch, SetStateAction } from "react";
import { FlexRow } from "src/utils/flexLayouts";
import Checkbox from "src/pages/Reports/WorkPlaceReport/components/Checkbox";

type Props = {
  collapseAll: () => void;
  expandAll: () => void;
  checkedOption: number | null;
  setCheckedOption: Dispatch<SetStateAction<number | null>>;
};

function CollapseTable({
  expandAll,
  collapseAll,
  checkedOption,
  setCheckedOption,
}: Props) {
  const onExpandChecked = () => {
    setCheckedOption(0);
    expandAll();
  };
  const onCollapseChecked = () => {
    setCheckedOption(1);
    collapseAll();
  };

  return (
    <FlexRow className="justify-between gap-2 mb-4">
      <Checkbox
        checked={checkedOption === 0}
        onChange={onExpandChecked}
        title="Развернуть все рабочие места"
      />
      <Checkbox
        checked={checkedOption === 1}
        onChange={onCollapseChecked}
        title="Свернуть все рабочие места"
      />
    </FlexRow>
  );
}

export default CollapseTable;
